import { h } from '@stencil/core';

const Icon = ({ width = '20', height = '20' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20">
      <circle cx="10" cy="10" r="10" fill="currentColor" />
      <path
        d="M8.906 12.626c0-.624.138-1.14.414-1.548.288-.408.702-.858 1.242-1.35.396-.36.684-.66.864-.9.192-.252.288-.534.288-.846 0-.444-.18-.792-.54-1.044-.348-.264-.816-.396-1.404-.396-.564 0-1.068.12-1.512.36a3.142 3.142 0 0 0-1.098.972L4.982 6.596a5.055 5.055 0 0 1 2.034-1.782c.864-.42 1.884-.63 3.06-.63 1.38 0 2.484.294 3.312.882.84.588 1.26 1.404 1.26 2.448 0 .492-.084.924-.252 1.296a3.3 3.3 0 0 1-.594.954c-.228.252-.528.546-.9.882-.444.396-.768.732-.972 1.008-.204.264-.306.588-.306.972H8.906Zm1.368 4.518c-.492 0-.906-.156-1.242-.468a1.595 1.595 0 0 1-.486-1.17c0-.456.162-.834.486-1.134.324-.312.738-.468 1.242-.468s.918.156 1.242.468c.324.3.486.678.486 1.134 0 .456-.168.846-.504 1.17-.324.312-.732.468-1.224.468Z"
        fill="white"
      />
    </svg>
  );
};

export default Icon;
